import {
  PromotionCardData,
  PromotionPanelData,
} from '../interfaces/promotion-cards.interface';

export const PROMOTION_PANELS: PromotionPanelData[] = [
  {
    id: 'media-channel',
    groups: [
      {
        title: '미디어 매체',
        items: [
          {
            id: 'broadcast',
            title: '방송 송출',
            imageUrl: '/event/promotion-broadcast.png',
            description:
              '현장 실시간 라이브 또는 녹화방송으로 송출하여 현장뿐 아니라 온라인에서도 시청할 수 있도록 지원합니다. 유튜브, SNS 등 다양한 플랫폼과 연계해 홍보 효과를 극대화합니다.',
          },
          {
            id: 'studio',
            title: '스튜디오',
            imageUrl: '/event/promotion-studio.png',
            description:
              '제품소개, 기업인터뷰, 홍보영상, 라이브 방송 등을 전문 스튜디오에서 기획부터 촬영, 편집까지 원스톱 제작합니다.',
          },
          {
            id: 'vcr',
            title: 'VCR',
            imageUrl: '/event/promotion-vcr.png',
            description:
              '방송 프로그램 중간 5~6분 분량의 선전 광고 송출 오프닝, 기업소개, 업체홍보, 제품소개 등 브랜드 노출의 기회를 제공합니다.',
          },
          {
            id: 'on-site-filming',
            title: '현장 촬영',
            imageUrl: '/event/promotion-on-site-filming.png',
            description:
              '행사 현장을 사진과 영상으로 전문 촬영하여 실시간 홍보 및 사후 마케팅 콘텐츠로 제작합니다.',
          },
        ],
      },
    ],
  },
  {
    id: 'online-promotion',
    groups: [
      {
        title: '온라인 홍보',
        items: [
          {
            id: 'sns-marketing',
            title: 'SNS 마케팅',
            imageUrl: '/event/promotion-sns-marketing.png',
            description:
              '인스타그램, 페이스북, 블로그, 유튜브 등 다양한 SNS 채널을 활용하여 행사와 참가기업을 효과적으로 홍보합니다.',
          },
          {
            id: 'official-website',
            title: '공식 홈페이지 홍보',
            imageUrl: '/event/promotion-official-website.png',
            description:
              '좋은공간, 밀리언쇼 등 공식 홈페이지를 활용하여 진행 예정 및 진행 중인 행사를 지속적으로 홍보하고 행사 관련 사진과 영상으로 노출합니다.',
          },
        ],
      },
    ],
  },
  {
    id: 'field-promotion',
    groups: [
      {
        title: '선전 홍보',
        items: [
          {
            id: 'banner',
            title: '현수막 홍보',
            imageUrl: '/event/promotion-banner.png',
            description:
              '행사장 및 주요 거점에 현수막을 설치하여 행사 개최 및 참가 정보를 효과적으로 안내하고 홍보합니다.',
          },
          {
            id: 'streetlight-banner',
            title: '가로등 배너 홍보',
            imageUrl: '/event/promotion-streetlight-banner.png',
            description:
              '행사 개최 지역의 주요 도로와 거리 가로등에 배너를 설치하여 행사 개최를 알리고 방문을 유도합니다.',
          },
        ],
      },
      {
        title: '현장국 홍보',
        items: [
          {
            id: 'visitors',
            title: '참관객 홍보',
            imageUrl: '/event/promotion-visitors.png',
            description:
              '문자발송, 온라인광고, 이메일, SNS 등 다양한 채널을 활용하여 잠재 참관객을 모집하고 행사 참여를 유도합니다.',
          },
          {
            id: 'recommended-companies',
            title: '추천 업체 홍보',
            imageUrl: '/event/promotion-recommended-companies.png',
            description:
              '행사 참가업체 및 협력업체를 다양한 온·오프라인 홍보 채널을 통해 소개하고 기업 홍보를 지원합니다.',
          },
        ],
      },
    ],
  },
];

export const PROMOTION_CARDS: PromotionCardData[] = [
  {
    id: 'media-channel',
    title: '미디어매체',
    subtitle: 'Media Channel',
    imageUrl: '/event/media-channel.png',
    mainPoints: [
      '지역방송 TV Spot 광고',
      '기자간담회를 통한 지역 일간지 특집 기사 유도',
    ],
    additionalInfo: [
      '• 지역별 방송국 60-70분 <span class="text-orange-500">특별방송</span>(연예인 부스 탐방)',
      '• 후원 방송사 TV, Radio를 통한 광고 홍보, 각 채널의 문화 프로그램에 행사의 <span class="text-orange-500">적극적인 노출</span>',
    ],
  },
  {
    id: 'online-promotion',
    title: '온라인 홍보',
    subtitle: 'Online Promotion',
    imageUrl: '/event/online-promotion.png',
    mainPoints: [
      '공식 홈페이지 및 온라인 커뮤니티 활성화',
      '후원/협찬 기관 홈페이지 팝업창 및 배너홍보',
      '티켓몬스터, 쿠팡, 위메프 등 소셜 커머스 제휴 및 온라인 바이럴 마케팅 전개',
    ],
    additionalInfo: [
      '• 온라인 프로모션 전개 - 방문고객을 위한 <span class="text-orange-500">무료입장권 이벤트 전개</span>',
      '• 자치단체, 창업관련단체, 포털사이트, 각 지역 대학, 창업 및 위업관련사이트 등 <span class="text-orange-500">Web Promotion 강화</span>',
    ],
  },
  {
    id: 'promotion-materials',
    title: '선전 홍보물',
    subtitle: 'Promotion Materials',
    imageUrl: '/event/promotion-materials.png',
    mainPoints: [
      '홍보물 및 현수막 제작 (포스터, 팜플렛 등)',
      '지역별 중요 인구 밀집지역 – 플래카드 및 가로등 배너 게첨',
      '지역 소재 대학 – 플래카드 및 홍보물 부착',
    ],
    additionalInfo: [
      '• 전시장 입구 – <span class="text-orange-500">대형 현수막 부착</span>',
      '• 단계별 광고 전략 수립 – 광고매체 및 방법 (대외, 일간지, 시사지, 창업신문 등) <span class="text-orange-500">언론보도</span>',
    ],
  },
  {
    id: 'audience-mobilization',
    title: '현장국 홍보',
    subtitle: 'Audience Mobilization',
    imageUrl: '/event/audience-mobilization.png',
    mainPoints: [
      '1, 2, 3회 박람회 참관객 DB 초청장 발송',
      '지역 대학 분부 관계처 구축을 통한 대상학생 참관 유도',
      '지역 기관, 기업 및 관련단체 초청장 5만부 발송',
    ],
    additionalInfo: [
      '• 관련 단체/협회 대상 및 대학에 제휴 마케팅 제안 전달 사전 <span class="text-orange-500">행사 기대감 증폭</span>',
    ],
  },
];
